import { Navigate } from "react-router-dom";
import useAuth from "./useAuth";

const PrivateRoute = ({ children }: any) => {
  const auth = useAuth();

  if (!auth?.isAuthenticated()) {
    return <Navigate to="/" replace />;
  }
  return children;
};
export default PrivateRoute;
